(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ranimahal-arrivals"] && !Shopify.designMode) return;
  try {
    (() => {
    const setup = (root = document) => {
      root.querySelectorAll('[data-rm-gallery]').forEach(gallery => {
        if (gallery.dataset.rmReady) return;
        gallery.dataset.rmReady = 'true';
        const dialog = gallery.querySelector('dialog');
        const body = gallery.querySelector('[data-rm-preview-body]');
        const tools = gallery.querySelector('[data-rm-tools]');
        const cards = Array.from(gallery.querySelectorAll('[data-rm-look]'));
        const buttons = Array.from(gallery.querySelectorAll('[data-rm-filter]'));
        const count = gallery.querySelector('[data-rm-count]');
        const search = gallery.querySelector('[data-rm-design-search]');
        const empty = gallery.querySelector('[data-rm-empty]');
        const normalize = value => value.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
        let chosen = 'all';
        let opener;
        const filter = value => {
          chosen = buttons.some(button => button.dataset.rmFilter === value) ? value : 'all';
          const terms = normalize(search?.value || '').split(' ').filter(Boolean);
          let total = 0;
          cards.forEach(card => {
            const haystack = normalize(card.dataset.search || '');
            card.hidden = (chosen !== 'all' && card.dataset.mood !== chosen) || !terms.every(term => haystack.includes(term));
            if (!card.hidden) total++;
          });
          buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.rmFilter === chosen)));
          if (count) count.textContent = (total === 1 ? count.dataset.singleLabel : count.dataset.countLabel).replace('[count]', total);
          if (empty) empty.hidden = total !== 0;
        };
        const saveFilters = () => {
          const url = new URL(location.href);
          chosen === 'all' ? url.searchParams.delete('edit') : url.searchParams.set('edit', chosen);
          search?.value.trim() ? url.searchParams.set('q', search.value.trim()) : url.searchParams.delete('q');
          history.replaceState(null, '', url);
        };
        if (tools) {
          tools.hidden = false;
          gallery.querySelector('[data-rm-search-wrap]').hidden = false;
          const params = new URLSearchParams(location.search);
          search.value = params.get('q') || '';
          filter(params.get('edit') || 'all');
          search.addEventListener('input', () => { filter(chosen); saveFilters(); });
        }
        gallery.addEventListener('click', event => {
          const button = event.target.closest('[data-rm-filter]');
          if (button) { filter(button.dataset.rmFilter); saveFilters(); return; }
          if (event.target.closest('[data-rm-reset]')) { search.value = ''; filter('all'); saveFilters(); search.focus(); return; }
          const trigger = event.target.closest('[data-rm-preview]');
          if (trigger && dialog && typeof dialog.showModal === 'function' && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
            const template = document.getElementById(trigger.dataset.rmPreview);
            if (!template) return;
            event.preventDefault(); opener = trigger; body.replaceChildren(template.content.cloneNode(true)); dialog.setAttribute('aria-labelledby', template.id + '-title'); dialog.showModal();
          }
          if (event.target.closest('[data-rm-close]')) dialog.close();
        });
        dialog.addEventListener('close', () => { body.replaceChildren(); opener?.focus(); });
        dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(), { once:true }); else setup();
    document.addEventListener('shopify:section:load', event => setup(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ranimahal-lookbook-search"] && !Shopify.designMode) return;
  try {
    document.addEventListener('input', event => {
    if (!event.target.matches('input[name="q"]')) return;
    const form = event.target.closest('form');
    form?.querySelectorAll('[data-rm-lookbook-link]').forEach(link => {
      const url = new URL(link.dataset.baseUrl, location.origin);
      if (event.target.value.trim()) url.searchParams.set('q', event.target.value.trim());
      link.href = url.toString();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
